export default "__VITE_ASSET__B4aNeuPN__"